import { FormTemplate } from '../schema';

export const GENERAL_INTAKE_TEMPLATE: FormTemplate = {
  id: 'general-intake-v1',
  name: 'Intake Geral - Novo Cliente',
  description: 'Formulário de coleta de informações básicas para novos clientes',
  category: 'intake',
  sections: [
    {
      key: 'personal_info',
      title: 'Informações Pessoais',
      description: 'Dados básicos do cliente',
      fields: [
        { 
          key: 'full_name', 
          type: 'text', 
          label: 'Nome Completo', 
          placeholder: 'Digite seu nome completo',
          required: true,
          fullWidth: true
        },
        { 
          key: 'email', 
          type: 'email', 
          label: 'Email', 
          placeholder: 'seu@email.com',
          required: true 
        },
        { 
          key: 'phone', 
          type: 'phone', 
          label: 'Telefone', 
          placeholder: '+1 (555) 123-4567',
          required: true 
        },
        { 
          key: 'date_of_birth', 
          type: 'date', 
          label: 'Data de Nascimento', 
          required: true 
        },
        { 
          key: 'country_of_birth', 
          type: 'country', 
          label: 'País de Nascimento', 
          required: true 
        },
        { 
          key: 'nationality', 
          type: 'country', 
          label: 'Nacionalidade Atual', 
          required: true 
        },
      ]
    },
    {
      key: 'current_address',
      title: 'Endereço Atual',
      description: 'Onde você mora atualmente',
      fields: [
        {
          key: 'address',
          type: 'address',
          label: 'Endereço Completo',
          required: true,
          fullWidth: true,
          addressFields: ['street', 'city', 'state', 'zip', 'country']
        }
      ]
    },
    {
      key: 'current_status',
      title: 'Status Imigratório Atual',
      description: 'Informações sobre seu status atual nos EUA',
      fields: [
        {
          key: 'currently_in_us',
          type: 'radio',
          label: 'Você está atualmente nos Estados Unidos?',
          required: true,
          options: [
            { value: 'yes', label: 'Sim' },
            { value: 'no', label: 'Não' }
          ]
        },
        {
          key: 'current_visa_status',
          type: 'select',
          label: 'Status atual do visto',
          required: true,
          conditional: { field: 'currently_in_us', value: 'yes' },
          options: [
            { value: 'tourist_b1b2', label: 'Turista (B1/B2)' },
            { value: 'student_f1', label: 'Estudante (F-1)' },
            { value: 'work_h1b', label: 'Trabalho (H-1B)' },
            { value: 'work_l1', label: 'Transferência (L-1)' },
            { value: 'investor_e2', label: 'Investidor (E-2)' },
            { value: 'pending_asylum', label: 'Asilo Pendente' },
            { value: 'lpr', label: 'Residente Permanente (Green Card)' },
            { value: 'citizen', label: 'Cidadão Americano' },
            { value: 'other', label: 'Outro' },
            { value: 'none_overstay', label: 'Sem status (overstay)' }
          ]
        },
        {
          key: 'visa_expiration',
          type: 'date',
          label: 'Data de expiração do visto/status',
          conditional: { field: 'currently_in_us', value: 'yes' },
          helperText: 'Se aplicável'
        }
      ]
    },
    {
      key: 'immigration_goal',
      title: 'Objetivo Imigratório',
      description: 'O que você está buscando?',
      fields: [
        {
          key: 'primary_goal',
          type: 'select',
          label: 'Qual é seu objetivo principal?',
          required: true,
          options: [
            { value: 'green_card_family', label: 'Green Card por família' },
            { value: 'green_card_work', label: 'Green Card por trabalho' },
            { value: 'citizenship', label: 'Cidadania Americana' },
            { value: 'visa_work', label: 'Visto de trabalho' },
            { value: 'visa_investor', label: 'Visto de investidor' },
            { value: 'visa_student', label: 'Visto de estudante' },
            { value: 'asylum', label: 'Asilo' },
            { value: 'deportation_defense', label: 'Defesa contra deportação' },
            { value: 'other', label: 'Outro' }
          ]
        },
        {
          key: 'goal_details',
          type: 'textarea',
          label: 'Detalhes adicionais sobre seu caso',
          placeholder: 'Conte-nos mais sobre sua situação e o que você espera alcançar...',
          fullWidth: true
        },
        {
          key: 'urgency',
          type: 'radio',
          label: 'Qual a urgência do seu caso?',
          options: [
            { value: 'very_urgent', label: 'Muito urgente (prazo imediato)' },
            { value: 'urgent', label: 'Urgente (próximos 30 dias)' },
            { value: 'normal', label: 'Normal (próximos 3 meses)' },
            { value: 'planning', label: 'Planejamento futuro' }
          ]
        }
      ]
    },
    {
      key: 'additional_info',
      title: 'Informações Adicionais',
      fields: [
        {
          key: 'how_found_us',
          type: 'select',
          label: 'Como você nos encontrou?',
          options: [
            { value: 'referral', label: 'Indicação de amigo/familiar' },
            { value: 'google', label: 'Pesquisa no Google' },
            { value: 'social_media', label: 'Redes sociais' },
            { value: 'youtube', label: 'YouTube' },
            { value: 'advertisement', label: 'Anúncio' },
            { value: 'other', label: 'Outro' }
          ]
        },
        {
          key: 'referral_name',
          type: 'text',
          label: 'Nome de quem indicou',
          conditional: { field: 'how_found_us', value: 'referral' }
        },
        {
          key: 'preferred_contact',
          type: 'radio',
          label: 'Forma preferida de contato',
          options: [
            { value: 'phone', label: 'Telefone' },
            { value: 'email', label: 'Email' },
            { value: 'whatsapp', label: 'WhatsApp' }
          ]
        },
        {
          key: 'best_time_contact',
          type: 'select',
          label: 'Melhor horário para contato',
          options: [
            { value: 'morning', label: 'Manhã (8h-12h)' },
            { value: 'afternoon', label: 'Tarde (12h-18h)' },
            { value: 'evening', label: 'Noite (18h-21h)' }
          ]
        }
      ]
    }
  ],
  settings: {
    allowSaveDraft: true,
    showProgress: true,
    requireSignature: false,
    confirmationMessage: 'Obrigado por preencher o formulário! Entraremos em contato em breve.',
    expiresInDays: 7,
    notifyOnComplete: true
  }
};
